<template>
  <header class="bg-surface-light p-4 w-full sticky top-0 shadow-sm left-0 right-0 max-h-[76px] flex flex-row items-center justify-between z-10">
    <!-- LHS -->
    <div
      class="flex items-center justify-start flex-grow max-w-1/2 w-full"
    >
      <span
        class="flex space-x-2 items-center cursor-pointer"
        @click="$emit('exit')"
      >
        <AM3Icon
          type="chevron-left"
          size="md"
        />
        <AM3Icon
          type="logo-brand"
          size="xl"
        />
      </span>
    </div>
    <!-- RHS -->
    <div class="space-x-4 flex flex-row items-center">
      <slot name="actions" />
      <AM3Button
        v-if="secondaryButtonText"
        icon-left="cog"
        type="tertiary"
        :text="secondaryButtonText"
        @click="$emit('secondary-action')"
      />
      <AM3Button
        v-submit="submitFormId"
        type="primary"
        :icon-left="actionButtonIcon"
        :text="actionButtonText"
        size="md"
        :disabled="actionButtonDisabled"
        @click="$emit('action')"
      />
    </div>
  </header>
</template>

<script setup>
import AM3Button from '@/components/am3-generic/base/AM3Button.vue'
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'

defineProps({
  actionButtonText: {
    type: String,
    default: 'Save',
  },
  actionButtonIcon: {
    type: String,
    default: '',
  },
  actionButtonDisabled: {
    type: Boolean,
    default: false,
  },
  /** Label for an optional tertiary button (e.g. a campaign's "Advanced Settings") - hidden when empty */
  secondaryButtonText: {
    type: String,
    default: '',
  },
  /** Form id the primary action button registers itself under via v-submit - see AM3FormValidation */
  submitFormId: {
    type: String,
    required: true,
  },
})

defineEmits(['exit', 'secondary-action', 'action'])
</script>
